import { useQuery } from '@apollo/client/react'

import { graphql } from '~publish/graphql'
import type { ResultOf } from '~publish/graphql'

export const GetChannelGroups = graphql(/* GraphQL */ `
  query GetChannelGroups($input: ChannelGroupsInput!) {
    channelGroups(input: $input) {
      __typename
      ... on ChannelGroupsResponse {
        channelGroups {
          id
          name
          accountId
          createdAt
          organizationId
          updatedAt
          channelCount
          channels {
            id
            name
            avatar
            type
            service
          }
        }
      }
    }
  }
`)

type GetChannelGroupsResult = ResultOf<typeof GetChannelGroups>

type ChannelGroupsResponse = Extract<
  NonNullable<GetChannelGroupsResult['channelGroups']>,
  { __typename: 'ChannelGroupsResponse' }
>

export type ChannelGroup_ChannelGroup =
  ChannelGroupsResponse['channelGroups'][number]

export type ChannelGroup_Channel = NonNullable<
  ChannelGroup_ChannelGroup['channels']
>[number]

export const useChannelGroups = ({
  accountId,
  organizationId,
}: {
  accountId: string
  organizationId: string
}): {
  channelGroups: ChannelGroup_ChannelGroup[] | null
  loading: boolean
  error: boolean
} => {
  const { data, loading, error } = useQuery(GetChannelGroups, {
    variables: {
      input: {
        accountId,
        organizationId,
        limit: null,
      },
    },
    skip: !accountId || !organizationId,
  })

  if (!data?.channelGroups) {
    return {
      channelGroups: null,
      loading,
      error: !!error,
    }
  }

  if (data.channelGroups.__typename !== 'ChannelGroupsResponse') {
    return {
      channelGroups: null,
      loading,
      error: true,
    }
  }

  return {
    channelGroups: data.channelGroups.channelGroups,
    loading,
    error: !!error,
  }
}
